/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectionManagementWizard/interfaces"/>
import { ListItem, SortInfo } from "@medius/ui-controls";

export enum RejectionManagementWizardType {
    Delete,
    Invalidate,
    InvalidateAndEdit
}

export enum RejectionType {
    Delete,
    Invalidate
}

//Needs to be in sync with back-end RejectedEntityType from RejectedEntityType.cs
export enum RejectedEntityType {
    SupplierInvoice = "SupplierInvoice",
    EdiDocumentImport = "EdiDocumentImport",
    CaptureDocument = "CaptureDocument"
}

export interface IRejectionManagementReasonCode {
    id: number;
    reasonCode: string;
    description: string;
    systemReasonCode: string;
    operations: string[];
    types: string[];
    isSystemReasonCode: boolean;
    rejectionActionId? : number | null
}

export enum ReasonCodeType {
    Internal = "Internal",
    External = "External"
}

export interface IRejectionAction {
    id: number;
    code: string;
    name: string;
    description: string;
}

export interface ISupplierInvoiceRejectionDto {
    documentId: number;
    documentType: string;
    operation: string;
    task: string;
    rejectedEntityType: string;
    rejectionType: RejectionType;
    invoiceRejectionReasonItems: IInvoiceRejectionReasonItem[];
    hasExternalReasonCode: boolean;
    sendToSupplier: boolean;
    invoiceRejectionEmail?: IInvoiceRejectionEmailDto;
}

export interface IInvoiceRejectionEmailDto {
    emailTo: IRecipientAddress[];
    carbonCopy: IRecipientAddress[];
    sendCopy: boolean;
    messageSubject: boolean;
    content: string;
}

export interface IRecipientAddress {
    value: string;
}

export interface IInvoiceRejectionReasonItem {
    reasonCodeId: number;
    actionId?: number | null;
}

export interface IInvoiceReasonCodeData {
    invoiceReasonCodes: IRejectionManagementReasonCode[];
    companyConfiguration: CompanyConfiguration;
    totalInvoiceReasonCodeCount: number;
    actions: ListItem[];
    isLoading: boolean;
    isError: boolean;
    paging: {
        currentPage: number;
        pageSize: number;
        changePage: (newPage: number) => void;
        changePageSize: (newPageSize: number) => void;
    };
    sorting: {
        sortInfo: SortInfo | null;
        changeSortInfo: (sortInfo: SortInfo | null) => void;
    };
    searching: {
        changeSearchTerm: (term: string) => void;
    };
}

export interface IEmailSettings { 
    currentUserEmail : string;
    currentUserLanguageCode : string;
    supplierLanguageCode : string;
}

export interface IEmailContent {
    subject: string;
    body: string;
}

export interface IEligibleForEmailCommunication {
    isEligible: boolean;
}

export interface CompanyConfiguration {
    isReasonRequiredUponRejection: boolean;
    supplierEmailForRejections: SupplierEmailForRejections;
}

export enum SupplierEmailForRejections
{
    suppliersContactPerson = "suppliersContactPerson",
    sendersEmailAddress = "sendersEmailAddress"
}

export interface DefaultSupplierEmail {
    emailSenderAddress?: string;
    supplierContactPersons: string[];
}

export interface RejectionReasonSelectionDto {
    reasonCode: string;
    reasonCodeDescription: string;
    rejectionActionCode?: string | null;
    rejectionActionDescription?: string | null;
}

export interface RejectionEmailContentRequestDto {
    invoiceRejectionReasons: RejectionReasonSelectionDto[],
    languageCode: string
}